const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Send a new chat message
 */
export const sendChatMessage = async ({
  family_id,
  task_id,
  user_id,
  member_id = null,
  secret = false,
  message,
  uploaded_file = null,
  file_metadata = null
}) => {
  const response = await fetch(`${BASE_URL}/utils/sendChatMessage_v2.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      family_id,
      task_id,
      user_id,
      member_id,
      secret,
      message,
      uploaded_file,
      file_metadata,
      timestamp: new Date().toISOString(),
      updated_at: new Date().toISOString()
    })
  });

  if (!response.ok) {
    throw new Error(`Failed to send message: ${response.statusText}`);
  }

  return response.json();
};

/**
 * Fetch chat messages
 */
export const fetchChatMessages = async (familyId, taskId) => {
  const params = new URLSearchParams({
    action: 'fetchChat',
    familyID: familyId,
    taskID: taskId
  });

  const response = await fetch(`${BASE_URL}/utils/fetchChatMessages_v2.php?${params.toString()}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch history: ${response.statusText}`);
  }

  const data = await response.json();
  return Array.isArray(data) ? data : [];
};

/**
 * Fetch older chat messages (pagination)
 */
export const fetchOlderChatHistory = async (familyId, taskId, offset, search = null) => {
  const params = new URLSearchParams({
    action: 'fetchOlderChat',
    familyID: familyId,
    taskID: taskId,
    offset: offset.toString()
  });

  if (search) {
    params.append('searchQuery', search);
  }

  const response = await fetch(`${BASE_URL}/utils/fetchChatMessages_v2.php?${params.toString()}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch older history: ${response.statusText}`);
  }

  const data = await response.json();
  return Array.isArray(data) ? data : [];
};

/**
 * Edit an existing message
 */
export const editChatMessage = async ({ family_id, task_id, message_id, new_message }) => {
  const response = await fetch(`${BASE_URL}/utils/sendEditMessage.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      family_id,
      task_id,
      message_id,
      new_message,
      updated_at: new Date().toISOString()
    })
  });

  if (!response.ok) {
    throw new Error(`Failed to edit message: ${response.statusText}`);
  }

  return response.json();
};

/**
 * Delete (soft delete) a message
 */
export const deleteChatMessage = async ({ family_id, task_id, message_id }) => {
  const response = await fetch(`${BASE_URL}/utils/sendDeleteMessage.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      family_id,
      task_id,
      message_id
    })
  });

  if (!response.ok) {
    throw new Error(`Failed to delete message: ${response.statusText}`);
  }

  return response.json();
};

/**
 * Mark messages as read
 */
export const markMessagesAsRead = async ({
  family_id,
  task_id,
  message_ids,
  user_type = 'admin'
}) => {
  const response = await fetch(`${BASE_URL}/utils/sendReadAcknowledgement.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      family_id,
      task_id,
      message_ids,
      user_type
    })
  });

  if (!response.ok) {
    throw new Error(`Failed to mark messages as read: ${response.statusText}`);
  }

  return response.json();
};

export default {
  sendChatMessage,
  fetchChatMessages,
  fetchOlderChatHistory,
  editChatMessage,
  deleteChatMessage,
  markMessagesAsRead
};
